import {Box, Modal, ModalProps} from "@mui/material";
import { styled, Theme} from "@mui/material/styles";
import React, {MouseEvent, MouseEventHandler, useEffect, useInsertionEffect, useState} from "react";
import {SxProps} from "@mui/system";

const StyledModal = styled(Modal)(({theme}) =>
    ({
        '& .MuiBackdrop-root': {
            backdropFilter:'blur(5px)'
        }
    })
);

export interface BlurredBackdropModalProps extends ModalProps {
    handleClose: ()=> void;
    dialogSx: SxProps<Theme>;
    dialogWrapperSx?: SxProps<Theme>;
    disableBackdropClose?: boolean;
    disablePortal?:boolean;
}
export const BlurredBackdropModal = (props: BlurredBackdropModalProps) => {
    const {handleClose,disableBackdropClose = false,dialogSx,...restProps} = props;
    let modalContentClick=false;
    const disablePortal = props.disablePortal??true;
   const handleModalClose = (event:  MouseEvent<HTMLDivElement>)=> {
       if(!disableBackdropClose && !modalContentClick) {
           handleClose();
       }
       modalContentClick=false;
   }
   
    return (<StyledModal
         {...restProps}
         disablePortal={disablePortal}
         disableEscapeKeyDown={disableBackdropClose}
    >
        <Box sx={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            justifyContent: 'center',
            alignContent: 'center',
            width: '100%',
            height:'100%',
            ...props.dialogWrapperSx
        }} onClick={handleModalClose}>
            <style dangerouslySetInnerHTML={{__html:'body{overflow:hidden}'}}/>
            <Box onClick={()=>{modalContentClick=true;}} sx={{
                display: 'flex',
                flexDirection: 'column',
                flexWrap: 'nowrap',
                alignItems: 'stretch',
                maxWidth: '95%',
                backgroundColor: (theme: Theme) => theme.palette.background.default,
                borderRadius: 3,
                border: '0',
                boxShadow: 24,
                p: 0,
                maxHeight: '100%',
                overflow:'hidden'
                , ...dialogSx}}>
                {props.children}
            </Box>
        </Box>
    </StyledModal>);
}